import { Box, Typography } from '@mui/material';
import React, { FunctionComponent, useRef, useState } from 'react';

import { theme } from './theme';

export const AppShowcaseVideo: FunctionComponent = () => {
  const c = 0.56239015817;
  const maxHeight = 320 / c;

  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  const getWidth = () => Math.round(getHeight() * c);
  const getHeight = () => Math.min(maxHeight, window.innerHeight);
  const baseUrl =
    'assets/aplikacja-matematyka-gryzie/jak-uczyc%CC%81-sie%CC%A8-z-aplikacja%CC%A8-matematyka-gryzie';
  const urlMp4 = `${baseUrl}.mp4`;
  const urlWebM = `${baseUrl}.webm`;
  const urlPoster = `${baseUrl}.webp`;
  const videoElement = useRef(null);

  const playVideo = () => {
    videoElement.current
      .play()
      .then(() => {
        setIsPlaying(true);
      })
      .catch(() => {
        console.log('error while trying to play video');
      });
  };

  const pauseVideo = () => {
    setIsPlaying(false);
    videoElement.current.pause();
  };

  const togglePlaying = () => {
    if (!isPlaying) {
      playVideo();
    } else {
      pauseVideo();
    }
  };

  return (
    <Box
      height={getHeight()}
      position="relative"
      onClick={togglePlaying}
      style={{
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        cursor: 'pointer',
        margin: 'auto',
      }}
    >
      <video
        ref={videoElement}
        style={{
          margin: 'auto',
        }}
        width={getWidth()}
        height={getHeight()}
        playsInline={true}
        preload="none"
        poster={urlPoster}
      >
        <source src={urlWebM} type="video/webm" />
        <source src={urlMp4} type="video/mp4" />
      </video>
      {!isPlaying && (
        <Box
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.64)',
          }}
        >
          <Box
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Typography
              style={{ color: 'white' }}
              variant="h4"
              paragraph={true}
            >
              Jak dziala aplikacja Matematyka Gryzie?
            </Typography>
            <img
              width="148"
              height="148"
              src="assets/icons/play.svg"
              alt="Obejrzyj jak działa aplikacja Matematyka Gryzie"
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AppShowcaseVideo;
